import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SubtractIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M17.52 4H6.76C5 4 4 5 4 6.76V17.52C4 19.28 5 20.28 6.76 20.28H17.52C19.28 20.28 20.28 19.28 20.28 17.52V6.76C20.28 5 19.28 4 17.52 4ZM6.86 5.64H17.42C18.12 5.64 18.64 6.16 18.64 6.86V17.42C18.64 18.12 18.12 18.64 17.42 18.64H6.86C6.16 18.64 5.64 18.12 5.64 17.42V6.86C5.64 6.16 6.16 5.64 6.86 5.64Z" />
      <path d="M15.88 12.96V11.3H8.4V12.96H15.88Z" />
    </SvgIcon>
  );
});
